import React, { useContext } from "react";

import { AuthService } from "./service";

export const AuthContext = React.createContext<AuthService>({} as AuthService);
export const useAuth = () => useContext(AuthContext);
